/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminControllerBlock } from '../fn/admin/admin-controller-block';
import { AdminControllerBlock$Params } from '../fn/admin/admin-controller-block';
import { adminControllerCreate } from '../fn/admin/admin-controller-create';
import { AdminControllerCreate$Params } from '../fn/admin/admin-controller-create';
import { adminControllerDelete } from '../fn/admin/admin-controller-delete';
import { AdminControllerDelete$Params } from '../fn/admin/admin-controller-delete';
import { adminControllerFindAll } from '../fn/admin/admin-controller-find-all';
import { AdminControllerFindAll$Params } from '../fn/admin/admin-controller-find-all';
import { adminControllerFindById } from '../fn/admin/admin-controller-find-by-id';
import { AdminControllerFindById$Params } from '../fn/admin/admin-controller-find-by-id';
import { adminControllerFindLogs } from '../fn/admin/admin-controller-find-logs';
import { AdminControllerFindLogs$Params } from '../fn/admin/admin-controller-find-logs';
import { adminControllerFindMe } from '../fn/admin/admin-controller-find-me';
import { AdminControllerFindMe$Params } from '../fn/admin/admin-controller-find-me';
import { adminControllerRefresh } from '../fn/admin/admin-controller-refresh';
import { AdminControllerRefresh$Params } from '../fn/admin/admin-controller-refresh';
import { adminControllerSearchCursor } from '../fn/admin/admin-controller-search-cursor';
import { AdminControllerSearchCursor$Params } from '../fn/admin/admin-controller-search-cursor';
import { adminControllerSearchOffset } from '../fn/admin/admin-controller-search-offset';
import { AdminControllerSearchOffset$Params } from '../fn/admin/admin-controller-search-offset';
import { adminControllerSignIn } from '../fn/admin/admin-controller-sign-in';
import { AdminControllerSignIn$Params } from '../fn/admin/admin-controller-sign-in';
import { adminControllerSignOut } from '../fn/admin/admin-controller-sign-out';
import { AdminControllerSignOut$Params } from '../fn/admin/admin-controller-sign-out';
import { adminControllerUnblock } from '../fn/admin/admin-controller-unblock';
import { AdminControllerUnblock$Params } from '../fn/admin/admin-controller-unblock';
import { adminControllerUpdate } from '../fn/admin/admin-controller-update';
import { AdminControllerUpdate$Params } from '../fn/admin/admin-controller-update';
import { AdminDto } from '../models/admin-dto';
import { LogDto } from '../models/log-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminControllerFindAll()` */
  static readonly AdminControllerFindAllPath = '/api/admin';

  /**
   * 관리자 전체 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindAll$Response(params?: AdminControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminDto>>> {
    const obs = adminControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 전체 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindAll(params?: AdminControllerFindAll$Params, context?: HttpContext): Observable<Array<AdminDto>> {
    const resp = this.adminControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AdminDto>>): Array<AdminDto> => r.body)
    );
  }

  /** Path part for operation `adminControllerCreate()` */
  static readonly AdminControllerCreatePath = '/api/admin';

  /**
   * 관리자 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate$Response(params: AdminControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate(params: AdminControllerCreate$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerSearchOffset()` */
  static readonly AdminControllerSearchOffsetPath = '/api/admin/search/offset';

  /**
   * 관리자 오프셋 기반 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffset$Response(params: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<AdminDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = adminControllerSearchOffset(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 오프셋 기반 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffset(params: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<{
'items': Array<AdminDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.adminControllerSearchOffset$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<AdminDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<AdminDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerSearchCursor()` */
  static readonly AdminControllerSearchCursorPath = '/api/admin/search/cursor';

  /**
   * 관리자 커서 기반 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchCursor$Response(params: AdminControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<AdminDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = adminControllerSearchCursor(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 커서 기반 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchCursor(params: AdminControllerSearchCursor$Params, context?: HttpContext): Observable<{
'items': Array<AdminDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.adminControllerSearchCursor$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<AdminDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<AdminDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerFindMe()` */
  static readonly AdminControllerFindMePath = '/api/admin/me';

  /**
   * 현재 관리자 조회.
   *
   * 현재 로그인한 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindMe$Response(params?: AdminControllerFindMe$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminControllerFindMe(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 현재 관리자 조회.
   *
   * 현재 로그인한 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindMe(params?: AdminControllerFindMe$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminControllerFindMe$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerFindLogs()` */
  static readonly AdminControllerFindLogsPath = '/api/admin/{id}/logs';

  /**
   * 관리자 로그 조회.
   *
   * 특정 관리자의 로그를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindLogs$Response(params: AdminControllerFindLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = adminControllerFindLogs(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 로그 조회.
   *
   * 특정 관리자의 로그를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindLogs(params: AdminControllerFindLogs$Params, context?: HttpContext): Observable<{
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.adminControllerFindLogs$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerFindById()` */
  static readonly AdminControllerFindByIdPath = '/api/admin/{id}';

  /**
   * 관리자 단건 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindById$Response(params: AdminControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 단건 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindById(params: AdminControllerFindById$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerDelete()` */
  static readonly AdminControllerDeletePath = '/api/admin/{id}';

  /**
   * 관리자 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDelete$Response(params: AdminControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDelete(params: AdminControllerDelete$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerUpdate()` */
  static readonly AdminControllerUpdatePath = '/api/admin/{id}';

  /**
   * 관리자 정보 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdate$Response(params: AdminControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 정보 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdate(params: AdminControllerUpdate$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerSignIn()` */
  static readonly AdminControllerSignInPath = '/api/admin/signin';

  /**
   * 관리자 로그인.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSignIn()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignIn$Response(params: AdminControllerSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
}>> {
    const obs = adminControllerSignIn(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 로그인.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSignIn$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignIn(params: AdminControllerSignIn$Params, context?: HttpContext): Observable<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
}> {
    const resp = this.adminControllerSignIn$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
}>): {

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerSignOut()` */
  static readonly AdminControllerSignOutPath = '/api/admin/signout';

  /**
   * 관리자 로그아웃.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSignOut()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSignOut$Response(params?: AdminControllerSignOut$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = adminControllerSignOut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 로그아웃.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSignOut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSignOut(params?: AdminControllerSignOut$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.adminControllerSignOut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerRefresh()` */
  static readonly AdminControllerRefreshPath = '/api/admin/refresh';

  /**
   * 관리자 토큰 재발급.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerRefresh()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerRefresh$Response(params: AdminControllerRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;
}>> {
    const obs = adminControllerRefresh(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 토큰 재발급.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerRefresh$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerRefresh(params: AdminControllerRefresh$Params, context?: HttpContext): Observable<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;
}> {
    const resp = this.adminControllerRefresh$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;
}>): {

/**
 * 액세스 토큰
 */
'accessToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerBlock()` */
  static readonly AdminControllerBlockPath = '/api/admin/{id}/block';

  /**
   * 관리자 차단.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerBlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerBlock$Response(params: AdminControllerBlock$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminControllerBlock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 차단.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerBlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerBlock(params: AdminControllerBlock$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminControllerBlock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerUnblock()` */
  static readonly AdminControllerUnblockPath = '/api/admin/{id}/unblock';

  /**
   * 관리자 차단 해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerUnblock()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerUnblock$Response(params: AdminControllerUnblock$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminControllerUnblock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 차단 해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerUnblock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerUnblock(params: AdminControllerUnblock$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminControllerUnblock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

}
